// 日程一覧のソートキー
export type ScheduleSortKey =
  | 'production_id'
  | 'production_no'
  | 'model_name'
  | 'my'
  | 'production_division_id'
  | 'production_division_name'
  | 'language_id'
  | 'language_name'
  | 'maker_company_id'
  | 'maker_company_name'
  | 'preproduction'
  | 'g1'
  | 'g2'
  | 'g3'
  | 'g4'
  | 'completion'
  | 'mass_production'
  | 'draft_translation'
  | 'final_translation'
  | 'other_language_edit_request'
  | 'data_toss'
  | 'plan'
  | 'actual';

// 1ページに表示する行数:50行
export const N_DATA_PER_PAGE = 50;

// 英語だった場合の月表示
const monthNameList = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];

/**
 *  数字（○月）→英語表記変換
 */
export function GetMonthNameEnglish(monthNum: number): string {
  return monthNameList[monthNum - 1];
}

/**
 * Dateオブジェクトをフォーマットする
 * @param date
 * @param format
 * @returns
 */
export function getFormattedDate(date: Date, format: string) {
  const symbol = {
    M: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
  };

  const formatted = format.replace(/(M+|d+|h+|m+|s+)/g, (v) =>
    `${v.length > 1 ? '0' : ''}${symbol[v.slice(-1) as keyof typeof symbol]}`.slice(-2)
  );

  return formatted.replace(/(y+)/g, (v) => date.getFullYear().toString().slice(-v.length));
}

/**
 * Dateオブジェクトをフォーマットする(YY-MM-DD → YY/MM/DD)
 * @param date
 * @param format
 * @returns
 */
export function getFormattedYYMMDDFromStr(dateStr:string|undefined) {
  if(dateStr === null || dateStr === undefined){
    return null;
  }
  // YY-MM-DD → YY/MM/DD
  return dateStr.replaceAll('-', '/');
}